import { render } from "./StoreCategory.vue?vue&type=template&id=0a9164b2&scoped=true"
import script from "./StoreCategory.vue?vue&type=script&lang=js"
export * from "./StoreCategory.vue?vue&type=script&lang=js"

import "./StoreCategory.vue?vue&type=style&index=0&id=0a9164b2&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9164b2"]])

export default __exports__